<div class="d-flex align-items-center my-4">
	<h1 class="mr-auto my-0">{{'onvio.setup.migrations.dashboard' | translate}}</h1>
	<a href="{{ PREPARE_FOR_MIGRATION_LINK }}"
	   data-qe-id="migration-dashboard-learn-more-about-migrations-link" target="_blank" rel="noopener noreferrer">
		{{'onvio.setup.migrations.dashboard.learnMoreAboutMigrations' | translate}}
	</a>
</div>

<bento-alert [items]="alerts">
</bento-alert>

<ng-template #howToStartInfo>
	<div [bentoBusyLoader]="showInProgressBusyloader">
		<div class="migration-dashboard-info-panel p-4 panel-border" *ngIf="!inProgressMigrationData">
			<h3 class="m-0">{{'onvio.setup.migrations.HowToStartInfo.migrationWillShow' | translate}}</h3>
			<div class="mt-4 d-flex justify-content-around">
				<div class="migration-info-item">
					<div class="user-group-image item-image"></div>
					<span>{{'onvio.setup.migrations.HowToStartInfo.NetClientCS' | translate}}</span>
				</div>
				<div class="migration-info-item">
					<div class="folder-upload-image item-image"></div>
					<span>{{'onvio.setup.migrations.HowToStartInfo.CSSuite' | translate }}</span>
				</div>
				<div class="migration-info-item" *ngIf="hasLicenseFrp">
					<div class="book-image item-image"></div>
					<span>{{'onvio.setup.migrations.HowToStartInfo.ThirdPartyApp' | translate}}</span>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<div class="migration-status-for-all-products">
  <div class="card mb-3" [hidden]="!inProgressMigrationData"> <!--[hidden] is used instead ngIf to make app-inprogress be present in the DOM as it send request to get items-->
		<div class="card-header inprogress-card-header">
			<h4>{{'onvio.setup.migrations.status.inprogress' | translate }}</h4>
			<div class="timestamp" *ngIf="inProgressMigrationData && lastUpdatedTimestamp" data-testid="migration_status_lastUpdatedTimestamp">
				{{'onvio.setup.migrations.status.inprogress.last_updated' | translate}} {{lastUpdatedTimestamp}}
			</div>
		</div>
    <div class="card-body">
      <app-inprogress
              		[migrationSource]="migrationSource"
					[migrationHeaderColumns]="inProgressColumns"
					showApplicationName="true"
					showOnlyTable="true"
					(updateMigrationResult)="updateInProgressMigrationStatus($event)"
					(gotoProduct)="launchProduct($event)"
					(lastUpdatedTimestampUpdated)="updateLastUpdatedTimestamp($event)">
      </app-inprogress>
    </div>
  </div>

	<ng-container *ngTemplateOutlet="howToStartInfo"></ng-container>

  <div class="card mb-3 mt-3">
    <h3 class="card-header">{{'onvio.setup.migrations.status.completed' | translate }}</h3>
    <div class="card-body">
      <div [bentoBusyLoader]="showCompletedBusyloader">
        <p class="card-text h3" *ngIf="!completedMigrationData">
          {{'onvio.setup.migrations.nothing.completed' | translate }}
        </p>
      </div>

      <ng-container *ngIf="completedMigrationData && completedMigrationData.length">
        <h3 class="h1 mt-n1">
          {{completedMigrationData.length}} {{'onvio.setup.migrations.migrations' | translate }}
        </h3>
        <div class="last-migration-info">
          {{ 'onvio.setup.migrations.lastmigration.indays' | translate: {'days': daysAgo} }}
        </div>
      </ng-container>

      <app-completed
              [migrationSource]="migrationSource"
        [migrationHeaderColumns]="completedColumns"
		showActionsColumn="true"
		showApplicationNameColumn="true"
        showOnlyTable="true"
        (updateMigrationResult)="updateCompletedMigrationStatus($event)"
        (gotoProduct)="launchProduct($event)">
      </app-completed>
    </div>
  </div>
</div>
